import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate, useLocation } from "react-router-dom";
import CategoryTabs from "../component/TableByCategory";

let Userdetail = () => {
  let [data, setData] = useState();
  let [count, setCount] = useState();
  let navigate = useNavigate();
  const location = useLocation();
  const state = location.state;

  useEffect(() => {
    Start();
    User();
  }, []);

  let Start = async () => {
    console.log(state , 'stateeee')
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let User = async () => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token, id: state._id };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url_bbbs + "/admin/oneuser",
        data: {
          data: data,
        },
      })
        .then((dat) => {
          let parsedata = AesDecrypt(dat.data);
          let Jsson = JSON.parse(parsedata);

          if (Jsson.status === true) {
            let dataByCategory = {};

            Jsson.data.forEach((item) => {
              if (!dataByCategory[item.category]) {
                dataByCategory[item.category] = [];
              }
              dataByCategory[item.category].push(item);
            });
            console.log(dataByCategory, "Jsson 1");
            setData(dataByCategory);
            setCount(Jsson.data);
          } else {
            alert(Jsson.message);
          }
        })
        .catch((ee) => {
          alert(" Failed");
        });
    } catch (err) {
      alert(" Failed");
    }
  };

  let ClickCat = (re) => {
    console.log(re, "rrrrrrrrrrrrrr");
    navigate("/category", { state: re });
  };

  function convertAndFormatTimestamp(timestamp, targetTimezone = "en-US") {
    const date = new Date(timestamp);

    const options = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
      timeZoneName: "short",
    };

    return date.toLocaleString(targetTimezone, options);
  }

  return (
    <div> 
      <div className="row">
      <Header />
        <div className="col-10" style={{ overflowY : 'scroll' , height : '100vh' , scrollbarWidth : 'none' }}>
          <div className="row">
            <div style={{ marginTop: 20, marginBottom: 20 }}>
              <div className="row" >
                <p style={{ fontSize : 17 , fontWeight : '700' }} >User Detail</p>
                <div style={{ marginTop : 20  }} >
                  <div className="row" >
                    
                  </div>
                </div>
              </div>
            </div>
            <div>Count : {count?.length}</div>
            <CategoryTabs dataByCategory={data} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Userdetail;
